import React, { useState, useEffect, useMemo } from 'react';
import './css/CabañasDraft.css';
import CabañaFamiliar from '../../images/Cabañas/CabañaFamiliar.png';
import CabañaDoble from '../../images/Cabañas/CabañaDoble.png';
import CabañaDobleDeluxe from '../../images/Cabañas/CabañaDobleDeluxe.png';

const CabañasDraft = () => {
  const imagesCabaña = useMemo(
    () => [CabañaFamiliar, CabañaDoble, CabañaDobleDeluxe],
    []
  );

  const [imageIndex, setImageIndex] = useState(0);
  const [imageSrc, setImageSrcFamiliar] = useState(imagesCabaña[0]);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    let timer;

    if (isHovering) {
      timer = setInterval(() => {
        setImageIndex((prevIndex) => (prevIndex + 1) % imagesCabaña.length);
      }, 1000);
    } else {
      setImageIndex(1);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isHovering, imagesCabaña.length]);

  useEffect(() => {
    setImageSrcFamiliar(imagesCabaña[imageIndex]);
  }, [imageIndex, imagesCabaña]);

  return (
    <div className="containerCabañas">
      <a
        href="/Cabañas"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div className="descriptionCabañas">
          <div className="imageContainer">
            <div className="overlay"></div>
            <img src={imageSrc} alt="Cabañas" />
          </div>
          <p>
            <strong>CONOCE NUESTRAS CABAÑAS</strong>
            <br />
            <span className="precio font-bold">
              Temporada Alta: 1 de Noviembre al 31 de Marzo
              <br />
              Temporada Baja: 1 de Abril al 31 de Octubre
            </span>
          </p>
        </div>
      </a>
    </div>
  );
};

export default CabañasDraft;